/**
 * Gemeinsame Grundlagen der beiden Formular-Baukaesten.
 *
 * Beide Editoren - der fuer die allgemeinen Felder und der je Typ - brauchen
 * dieselben Feldtypen und dieselben Umrechnungen. Vorher stand das zweimal
 * da, mit der absehbaren Folge, dass eine Aenderung nur an einer Stelle
 * ankommt.
 *
 * Wichtig: Nach aussen erscheinen nur Klartextbezeichnungen. Wer ein
 * Formular gestaltet, soll "Mehrzeiliger Text" lesen und nicht "textarea".
 */

export const FELDTYPEN = [
    { wert: 'checkbox',    text: 'Ja/Nein',           hinweis: 'Ein Häkchen zum Ankreuzen' },
    { wert: 'text',        text: 'Text',              hinweis: 'Eine Zeile Text' },
    { wert: 'textarea',    text: 'Mehrzeiliger Text', hinweis: 'Mehrere Zeilen, etwa für Bemerkungen' },
    { wert: 'number',      text: 'Zahl',              hinweis: 'Nur Ziffern, etwa eine Größe' },
    { wert: 'date',        text: 'Datum',             hinweis: 'Ein Tag aus dem Kalender' },
    { wert: 'time',        text: 'Uhrzeit',           hinweis: 'Eine Uhrzeit' },
    { wert: 'select',      text: 'Auswahl',           hinweis: 'Eine Möglichkeit aus einer Liste' },
    { wert: 'multiselect', text: 'Mehrfachauswahl',   hinweis: 'Mehrere Möglichkeiten gleichzeitig' },
];

/** Feldarten, die der Server selbst fuellt und die niemand haendisch waehlt. */
const FESTGELEGTE_BEZEICHNUNGEN = {
    'costume-type-select': 'Typ-Auswahl',
    'type-questions':      'Felder des Typs',
    'section':             'Bestellbare Teile',
    'departure-list':      'Abfahrtsorte',
    'label':               'Nur Text',
};

/** Klartext zu einem Feldtyp. Nie der technische Name. */
export const typBezeichnung = (typ) =>
    FELDTYPEN.find(t => t.wert === typ)?.text
    || FESTGELEGTE_BEZEICHNUNGEN[typ]
    || typ;

export const brauchtOptionen = (typ) => typ === 'select' || typ === 'multiselect';

/**
 * Macht aus einer Beschriftung einen technischen Namen.
 *
 * Beim Ersatzteil bleibt die Bezeichnung unveraendert: dort ist der Name
 * zugleich das, was in der Bestellung landet - "Schürze" heisst dort auch in
 * den Daten "Schürze".
 */
export const technischerName = (beschriftung, bereich) => {
    const roh = (beschriftung || '').trim();
    if (bereich === 'ersatzteil') return roh;
    return roh
        .toLowerCase()
        .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '')
        .replace(/^([0-9])/, 'f$1') || 'feld';
};

// Auswahlmoeglichkeiten werden als "Anzeige = Wert" je Zeile bearbeitet. Der
// gespeicherte Wert steht in bestehenden Antraegen, die Anzeige nicht - beide
// muessen getrennt bleiben, sonst zeigen alte Eintraege ins Leere.
export const optionenZuText = (optionen) =>
    (optionen || [])
        .map(o => (o['frontend-text'] === o.value ? o.value : `${o['frontend-text']} = ${o.value}`))
        .join('\n');

export const textZuOptionen = (text) =>
    (text || '').split('\n').map(z => z.trim()).filter(Boolean).map(zeile => {
        const stelle = zeile.indexOf('=');
        if (stelle < 0) return { 'frontend-text': zeile, value: zeile };
        return {
            'frontend-text': zeile.slice(0, stelle).trim(),
            value: zeile.slice(stelle + 1).trim(),
        };
    });

/** Liest einen in der Datenbank abgelegten Bedingungswert. */
export const wertAusText = (text) => {
    if (text === 'true') return true;
    if (text === 'false') return false;
    return text;
};
